export default __webpack_public_path__ + "static/media/platformDeviceIcon2.35f689ef.webp";